import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { combineAll } from '@datachain/ui-sdk/common';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, of, switchMap } from 'rxjs';

import { refreshPics, setProject } from '../../core/store';
import { PicsRequester } from '../../requesters';
import { PicEntity } from '../domain/pic.entity';
import { ProjectAdapter } from '../project.adapter';
import {
	fetchPicsForProjectFail,
	fetchPicsForProjectSuccess,
} from './pics.actions';

@Injectable()
export class PicsEffects {
	// ##########################################################
	// Business Effects
	// ##########################################################

	public getPicsForProject$ = createEffect(() =>
		this.action$.pipe(
			ofType(setProject),
			switchMap(() => this.picsRequester.getAvailablePics()),
			map((result) =>
				fetchPicsForProjectSuccess({
					pics: result.map((r) =>
						PicEntity.build({
							isNew: false,
							label: r.lib,
							id: r.id,
						})
					),
				})
			),
			catchError((error: HttpErrorResponse, caught) => {
				console.error(error);
				this.store.dispatch(
					fetchPicsForProjectFail({
						error,
					})
				);
				return caught;
			})
		)
	);

	public refreshPicsForProject$ = createEffect(() =>
		this.action$.pipe(
			ofType(refreshPics),
			switchMap((action) =>
				combineAll({
					req: this.picsRequester.getAvailablePics(new Set(), true),
					recentUploads: of(action.recentUploads),
				})
			),
			map(({ req, recentUploads }) =>
				req.map((r) =>
					PicEntity.build({
						label: r.lib,
						id: r.id,
						isNew: recentUploads.has(r.lib),
					})
				)
			),
			map((pics) =>
				fetchPicsForProjectSuccess({
					pics,
				})
			),
			catchError((error: HttpErrorResponse, caught) => {
				console.error(error);
				this.store.dispatch(
					fetchPicsForProjectFail({
						error,
					})
				);
				return caught;
			})
		)
	);

	public constructor(
		private readonly action$: Actions,
		private readonly store: Store,
		private readonly adapter: ProjectAdapter,
		private readonly picsRequester: PicsRequester
	) {}
}
